(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("eyeson", [], factory);
	else if(typeof exports === 'object')
		exports["eyeson"] = factory();
	else
		root["eyeson"] = factory();
})(self, () => {
return 